import { Button, Icon } from "@mui/material";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { accountService } from "../../_services/accounts.service";
import { UserCreditManageDrawer } from "../userCredit/userCredit-manageDrawer";

export function InfoManageCreditButton() {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const [creditManagerOpen, setCreditManagerOpen] = useState(false);


    const [forms, setForms] = useState([]);
    const { userId } = useParams<{ userId: string }>();
    let navigate = useNavigate();

    return (
        <>

            {(userId && (!!accountService.isAdmin || !!accountService.isOrganiser)) &&
                <>
                    <Button
                        id="demo-customized-button"
                        aria-controls={open ? 'demo-customized-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        variant="contained"
                        disableElevation
                        onClick={() => { setCreditManagerOpen(true) }}
                        color="success"
                        style={{ "width": "100%", marginTop: "4px" }}
                        endIcon={<Icon>add</Icon>}
                    >
                        Add Credit Point
                    </Button>

                    {!!creditManagerOpen &&
                        <UserCreditManageDrawer
                            isOpen={!!creditManagerOpen}
                            itemId={null}
                            onSave={() => { setCreditManagerOpen(false); }}
                            onClose={() => { setCreditManagerOpen(false); }}
                        />
                    }
                </>
            }

        </>
    );

}
